import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var BitmapDataChannel = /** @class */ (function (_super) {
    __extends(BitmapDataChannel, _super);
    function BitmapDataChannel() {
        return _super.call(this) || this;
    }
    // Called whenever the class is initialized.
    BitmapDataChannel.classInitializer = null;
    // List of static symbols to link.
    BitmapDataChannel.classSymbols = null; // [];
    // List of instance symbols to link.
    BitmapDataChannel.instanceSymbols = null; // [];
    // JS -> AS Bindings
    BitmapDataChannel.ALPHA = 8;
    BitmapDataChannel.BLUE = 4;
    BitmapDataChannel.GREEN = 2;
    BitmapDataChannel.RED = 1;
    return BitmapDataChannel;
}(ASObject));
export { BitmapDataChannel };
